<template>
    <el-date-picker @change="pick" v-model="startAt" :picker-options="pickerOptions"
		type="month" size="small" style="width:120px" value-format="yyyy-MM" append-to-body />
</template>

<script>
export default {
	props:['value'],
	data(){
		const self = this;
		const getMonthDate = self.$utils.getMonthDate;
		const date_format = self.$utils.date_format;
		function getMonthDateStr(bias){
			const d = getMonthDate(bias);
			return date_format(d,'YYYY-MM');
		}
		function onClickGen(bias){
			return function(picker){
				const month = getMonthDateStr(bias);
				picker.$emit('pick','');
				self.startAt = month;
			}
		}
		return{
			startAt:getMonthDateStr(0),
			pickerOptions: {
				// disabledDate(time) {
				// 	return time.getTime() > Date.now();
				// },
				shortcuts: [
					{
						text: 'this Month',
						onClick:onClickGen(0),
					},
					{
						text: 'last Month',
						onClick:onClickGen(-1),
					},
					{
						text:'-2 Month',
						onClick:onClickGen(-2),
					},
					{
						text:'-3 Month',
						onClick:onClickGen(-3),
					},
					{
						text:'-4 Month',
						onClick:onClickGen(-4),
					}
				]
			}
		}
	},
	methods:{
		pick(){
			if(this.startAt){
				this.$emit('input',this.startAt);
			} else {
				this.$emit('input','');
			}
			
		}
	},
	mounted(){
		this.pick();
	}
}
</script>
<style scoped>
</style>

